import { useDefaultPagination } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/hooks/useInvoicesTransaction';
import { TransactionsDetailTable } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/Table/TransactionsDetailTable';
import { FC, memo, useMemo } from 'react';

type ErrorTransactionsDetailTableProps = {
  error: Error | null;
};

export const ErrorTransactionsDetailTable: FC<ErrorTransactionsDetailTableProps> =
  memo(() => {
    const pagination = useDefaultPagination();
    const tableProps = useMemo(
      () => ({ data: [], columns: [], loading: false, emptyType: 'error' }),
      []
    );
    return (
      <TransactionsDetailTable
        table={tableProps}
        pagination={pagination}
        isSearchEmpty={false}
      />
    );
  });
ErrorTransactionsDetailTable.displayName = 'ErrorTransactionsDetailTable';
